import * as React from 'react';
import {uniq} from 'ramda';
import Placeholder from 'react-bootstrap/Placeholder';
import {date} from 'ka-erp-data';
import {receiverName} from '../../lib/order';

const css = require('./order.css').default;

export default function ({order, onClick}: {
    order: order,
    onClick: (order: order) => void,
}) {
    const state = (() => {
        if (order.outOfStock) {
            return '缺';
        } else if (order.pkgs !== 'loading' && allDone(order.pkgs)) {
            return '✔'
        } else {
            return '　'
        }
        function allDone(pkgs: pkg[]) {
            return pkgs.length > 0 && pkgs.every(pkg.packed);
        }
    })();

    return (
    <div className={css.order} onClick={() => onClick(order)}>
        <div>
            <span className={state === '缺' ? 'icon red' : state === '✔' ? 'icon green' : 'icon'}>{state}</span>
        </div>
        <div className='data'>
            <div className='date'>{date.toDate(order.createDate).toLocaleDateString()}</div>
            <div className='title'>{title(order)}</div>
            <div className='digest'>{(() => {
                const pnames = order.items.map(i => i.product === 'loading' ? null : i.product.name);
                if (pnames.some(i => i === null)) {
                    return (
                    <>
                        <div><Placeholder xs={6}/></div>
                        <div><Placeholder xs={4}/></div>
                    </>);
                } else {
                    return uniq(pnames).join(', ');
                }
            })()}</div>
        </div>
    </div>);
}

function title(order: order) {
    if (order.memo) {
        const rname = receiverName(order);
        if (rname) {
            return `${order.memo} (${rname})`;
        } else {
            return order.memo;
        }
    } else {
        return receiverName(order) || '　';
    }
}

type order = {
    id: string,
    _id: number,
    createDate: date,           // 建立日期
    billDate: date,
    deliverDate: date | null,   // 預計出貨日
    receiverId: string | null,
    receiverName: string | null,
    address: string,
    memo: string | null,
    outOfStock: boolean,
    pkgs: pkg[] | 'loading',
    items: {
        _id: number,
        seq: number,
        product: {
            id: string,
            name: string,
        } | 'loading',
        qty: number,
        classCnt: number,
        giftQty: number | null,
        memo: string | null,
    }[],
}

type pkg = {
    order: string,
    logistic: string,
    items: {
        packDate: date | null,
    }[],
}

namespace pkg {
    export function packed(pkg: pkg) {
        return pkg.items.some(i => i.packDate !== null);
    }
}
